import React from "react";
import { useParams } from "react-router-dom";

import {
  Box,
  Grid,
  Typography,
} from "@mui/material";

import DetailsView from "../Common/Views/DetailsView";
import InventoryStockList from "../Inventory/Stock/InventoryStockList";


function LocationDataLayout({ data }) {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} lg={4}>
          <Typography variant="subtitle2" color="text.secondary">
            Name
          </Typography>
          <Typography variant="body2">{data.name || "-"}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <Typography variant="subtitle2" color="text.secondary">
            Type
          </Typography>
          <Typography variant="body2">{data.type || "-"}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <Typography variant="subtitle2" color="text.secondary">
            Phone number
          </Typography>
          <Typography variant="body2">{data.phoneNumber || "-"}</Typography>
        </Grid>

        <Grid item xs={12} sm={6} lg={4}>
          <Typography variant="subtitle2" color="text.secondary">
            Address
          </Typography>
          <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
            {data.address || "-"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <Typography variant="subtitle2" color="text.secondary">
            Additional Information
          </Typography>
          <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
            {data.additionalInfo || "-"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <Typography variant="subtitle2" color="text.secondary">
            Outlet
          </Typography>
          <Typography variant="body2">{data.hasOutlet ? "Yes" : "No"}</Typography>
        </Grid>
      </Grid>
    </>
  );
}


export default function LocationDetails() {
  const { id } = useParams();

  return (
    <>
      <DetailsView
        title="Location details"
        subtitleAttribute="name"
        apiPath={`/tenants/locations/${id}`}
        editPath={`/locations/${id}/edit`}
        onDelete={(data) => {
          console.log("Delete action for", data);
          // you can plug API delete call here
        }}
      >
        {({ data }) => <LocationDataLayout data={data} />}
      </DetailsView>

      <Box margin={{ xs: 1, sm: 2 }} mt={{ xs: 2, sm: 4 }} padding={{ xs: 1, sm: 2 }}>
        <InventoryStockList
          filters={{ locationId: id }}
          addButton={true}
          columns={['itemName', 'itemCode', 'itemUnitPrice', 'actualQuantity', 'reservedQuantity', 'availableQuantity']}
          searchBox={false}
          noResultsMessage="No inventory stock found in this location"
        />
      </Box>
    </>
  )
};